import React from 'react'
import type { ICellRendererParams } from 'ag-grid-community'
import { BBDTag, MaterialIcon } from '@gravitate-js/excalibrr'
import type { MatchStatus } from '../../../../MatchView/types/match'
import { MATCH_STATUS_CONFIG } from '../../../../MatchView/constants/statusConfig'
import type { InvoiceOverview } from '../types'

export function StatusCellRenderer({ value }: ICellRendererParams<InvoiceOverview, MatchStatus>) {
  if (!value) return null

  const config = MATCH_STATUS_CONFIG[value]
  if (!config) return value

  return (
    <BBDTag
      style={{ width: 'min-content' }}
      error={config.tagProps.error}
      warning={config.tagProps.warning}
      success={config.tagProps.success}
      theme2={config.tagProps.theme2}
      icon={<MaterialIcon icon={config.icon} fill size={8} className='mr-2' />}
    >
      {config.display}
    </BBDTag>
  )
}
